@if (!store.isSummary) {
    <section>
        <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    </section>
}

@if (showOwnMoney()) {
    <own-money></own-money>
}
@if (showOwnMoneyAmount()) {
    <own-money-amount></own-money-amount>
}
